export default "__VITE_ASSET__cbcd8fea__"